// import Swiper JS
import Swiper from 'swiper';
import 'swiper/css/swiper.css';

Drupal.behaviors.slider = {
  attach(context) {
    const sliders = document.querySelectorAll('.swiper-container');
    const controlSelector = '.swiper-playback';
    sliders.forEach((slider) => {
      if (!slider.classList.contains('swiper-container--processed')) {
        // eslint-disable-next-line no-new
        new Swiper(slider, {
          autoplay: {
            delay: 4321,
          },
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: slider.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
        });
      }
    });

    function controlSwiper(e) {
      const clickAlikes = [32, 12];
      if (e.type === 'keydown' && clickAlikes.indexOf(e.keyCode) === -1) {
        return false;
      }
      const control = document.querySelector(controlSelector);
      if (control) {
        const ele = e.target.closest(controlSelector) ? e.target.closest(controlSelector) : null;
        if (ele) {
          const curIcon = ele.dataset.icon;
          const parentSwiper = ele.closest('.swiper-container').swiper;
          if (curIcon === 'play') {
            ele.dataset.icon = 'pause';
            parentSwiper.autoplay.start();
          } else {
            ele.dataset.icon = 'play';
            parentSwiper.autoplay.stop();
          }
        } else {
          return false;
        }
      }
      return true;
    }

    (context || document).addEventListener('click', controlSwiper);
    (context || document).addEventListener('keydown', controlSwiper);
  },
};
